import React from "react";
import user from "../../../assets/user.jpg";

const SuccessPage = ({ onSubmit, onPrev, formData, imageData }) => {
  const imageSrc = imageData || user;

  return (
    <div className="p-2">
      <div className="bg-gray-200">
        <div className="mx-auto">
          <div className="flex justify-center md:px-6 py-6">
            <div className="w-full lg:w-7/12 p-5 rounded-lg lg:rounded-l-none">
              <div
                className="px-8 pt-6 pb-8 mb-4 bg-white rounded"
                style={{ backgroundColor: "rgb(255,255,255)" }}
              >
                {/* Profile Image */}
                <div className="flex flex-row mb-2 items-center justify-center">
                  <div className="mr-4">
                    <img
                      src={imageSrc}
                      alt="Doctor"
                      className="w-32 h-32 object-cover rounded-full"
                    />
                  </div>
                </div>

                {/* BASIC INFORMATION */}
                <p className="text-teal-500 font-semibold">
                  BASIC INFORMATION & PASSWORD CREATION
                </p>
                <div className="flex sm:flex-row flex-col mb-2">
                  <div className="flex flex-col flex-grow mr-4 mb-2">
                    <p className="text-gray-400">First Name</p>
                    <input
                      value={formData.firstName || ""}
                      readOnly
                      className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block p-2.5"
                    />
                  </div>
                  <div className="flex flex-col flex-grow mr-4 mb-2">
                    <p className="text-gray-400">Last Name</p>
                    <input
                      value={formData.lastName || ""}
                      readOnly
                      className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block p-2.5"
                    />
                  </div>
                </div>

                <div className="flex sm:flex-row flex-col mb-2">
                  <div className="flex flex-col flex-grow mr-4 mb-2">
                    <p className="text-gray-400">Email Id</p>
                    <input
                      value={formData.email || ""}
                      readOnly
                      className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block p-2.5"
                    />
                  </div>
                  <div className="flex flex-col flex-grow mr-4 mb-2">
                    <p className="text-gray-400">Contact No.</p>
                    <input
                      value={formData.contact || ""}
                      readOnly
                      className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block p-2.5"
                    />
                  </div>
                </div>

                <div className="flex sm:flex-row flex-col mb-2">
                  <div className="flex flex-col flex-grow mr-4 mb-2">
                    <p className="text-gray-400">Password</p>
                    <input
                      type="password"
                      value={formData.password || ""}
                      readOnly
                      className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block p-2.5"
                    />
                  </div>
                  <div className="flex flex-col flex-grow mr-4 mb-2">
                    <p className="text-gray-400">Confirm Password</p>
                    <input
                      value={formData.confirm_Password || ""}
                      readOnly
                      className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block p-2.5"
                    />
                  </div>
                </div>

                {/* QUALIFICATIONS */}
                <p className="text-teal-500 font-semibold mt-4">QUALIFICATIONS</p>
                {formData.doctors?.map((doctor, index) => (
                  <div key={index} className="flex sm:flex-row flex-col mb-2">
                    <div className="flex flex-col flex-grow mr-4 mb-2">
                      <p className="text-gray-400">Degree</p>
                      <input
                        value={doctor.degree || ""}
                        readOnly
                        className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block p-2.5"
                      />
                    </div>
                    <div className="flex flex-col flex-grow mr-4 mb-2">
                      <p className="text-gray-400">College</p>
                      <input
                        value={doctor.college || ""}
                        readOnly
                        className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block p-2.5"
                      />
                    </div>
                    <div className="flex flex-col flex-grow mr-4 mb-2">
                      <p className="text-gray-400">Year</p>
                      <input
                        value={doctor.year || ""}
                        readOnly
                        className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block p-2.5"
                      />
                    </div>
                  </div>
                ))}

                {/* Specialization */}
                <div className="flex flex-col mb-2">
                  {formData.specialization?.map((spec, index) => (
                    <div key={index} className="flex flex-col flex-grow mb-2">
                      <p className="text-gray-400">Specialization</p>
                      <input
                        value={spec || ""}
                        readOnly
                        className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block p-2.5"
                      />
                    </div>
                  ))}
                </div>

                {/* Achievements */}
                <div className="flex flex-col mb-2">
                  {formData.achievements?.map((ach, index) => (
                    <div key={index} className="flex flex-col flex-grow mb-2">
                      <p className="text-gray-400">Achievement</p>
                      <input
                        value={ach || ""}
                        readOnly
                        className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block p-2.5"
                      />
                    </div>
                  ))}
                </div>

                {/* Experience */}
                <div className="flex flex-col flex-grow mr-4 mb-2">
                  <p className="text-gray-400">Experience</p>
                  <input
                    value={formData.experience || ""}
                    readOnly
                    className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full md:w-1/2 p-2.5"
                  />
                </div>

                {/* Licence Number and Research Journals */}
                <div className="flex sm:flex-row flex-col mb-2">
                  <div className="flex flex-col flex-grow mr-4 mb-2">
                    <p className="text-gray-400">Licence Number</p>
                    <input
                      value={formData.licenceNumber || ""}
                      readOnly
                      className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block p-2.5"
                    />
                  </div>
                  <div className="flex flex-col flex-grow mr-4 mb-2">
                    {formData.research_journal?.map((journal, index) => (
                      <div key={index} className="mb-2">
                        <p className="text-gray-400">Research Journal</p>
                        <input
                          value={journal || ""}
                          readOnly
                          className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"
                        />
                      </div>
                    ))}
                  </div>
                </div>

                {/* Citations and Referral */}
                <div className="flex sm:flex-row flex-col mb-2">
                  <div className="flex flex-col flex-grow mr-4 mb-2">
                    {formData.citations?.map((citation, index) => (
                      <div key={index} className="mb-2">
                        <p className="text-gray-400">Citation</p>
                        <input
                          value={citation || ""}
                          readOnly
                          className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"
                        />
                      </div>
                    ))}
                  </div>
                  <div className="flex flex-col flex-grow mr-4 mb-2">
                    <p className="text-gray-400">Referral Mobile No.</p>
                    <input
                      value={formData.referral || ""}
                      readOnly
                      className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block p-2.5"
                    />
                  </div>
                </div>

                {/* Buttons */}
                <div className="flex justify-end">
                  <div className="mb-4 mr-2 text-center">
                    <button
                      className="w-full px-4 py-2 font-bold text-orange-500 border border-orange-500 bg-white rounded-full focus:outline-none"
                      type="button"
                      onClick={onPrev}
                    >
                      Back
                    </button>
                  </div>
                  <div className="mb-4 text-center">
                    <button
                      className="w-full px-4 py-2 font-bold text-white bg-orange-500 rounded-full hover:bg-orange-700 focus:outline-none"
                      type="submit"
                      onClick={onSubmit}
                    >
                      Submit
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SuccessPage;